export default __webpack_public_path__ + "static/media/create.eba327e2.png";